<template>
  <div class="loader-container" :class="{ show: isLoading }" role="alert" aria-live="assertive" :id="uuid">
    <div class="loader">Loading...</div>
  </div>
</template>
<script>
import idMixin from '@/mixins/aha-id';
export default {
  mixins: [ idMixin ], 
  props: {
    isLoading: {
      type: Boolean
    }
  },
  data() {
      return {
          uuid: null
      }
  },
  mounted() {
      this.uuid = this.safeId('_AHA_loading_spinner_');
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-loading-spinner.vue